import {
  CardTypes,
  CreditCardsDto,
  CreditCardsDtoTransformer,
  InvoiceDto,
  InvoicesLegacyDto,
  InvoicesTransporterDto,
  PaymentMethod,
  PaymentType,
  UserWalletConfigDto,
  UserWalletConfigModel
} from '../models/payments';

function getCardType(cardName: string) {
  switch (cardName.toUpperCase()) {
    case 'VISA':
      return CardTypes.VISA;
    case 'MASTERCARD':
      return CardTypes.MASTERCARD;
  }
}

export const invoicesLegacyDtoToPaymentMethods = ({ invoices }: InvoicesLegacyDto): PaymentMethod[] => {
  if (!invoices) {
    return [];
  }
  return invoices.map(invoiceDtoToPaymentMethod);
};

export const invoicesTransporterDtoToPaymentMethods = ({
  payment_options
}: InvoicesTransporterDto): PaymentMethod[] => {
  if (!payment_options) {
    return [];
  }
  return payment_options.map(invoiceDtoToPaymentMethod);
};

export const invoiceDtoToPaymentMethod = (invoice: InvoiceDto): PaymentMethod => ({
  paymentType: PaymentType.INVOICE,
  id: invoice.id,
  display: invoice.display,
  isReferenceRequired: invoice.is_reference_required
});

export const creditCardDtoToPaymentMethod = ({ cards }: CreditCardsDto): PaymentMethod[] => {
  if (!cards) {
    return [];
  }
  return cards.map(item => {
    const paymentMethod: PaymentMethod = {
      paymentType: PaymentType.CREDIT_CARD,
      id: item.id,
      display: `**** ${item.last_4}`,
      cardType: getCardType(item.type),
      //TODO: refactor when v2 rolled out
      expiryDate: item.expire_month ? `${item.expire_month}/${item.expire_year}` : undefined
    };
    return paymentMethod;
  });
};

export const creditCardDtoToPaymentMethodTransformer = ({ cards }: CreditCardsDtoTransformer): PaymentMethod[] => {
  if (!cards) {
    return [];
  }
  return cards.map(item => {
    const paymentMethod: PaymentMethod = {
      paymentType: PaymentType.CREDIT_CARD,
      id: item.id,
      display: `**** ${item.last_4}`,
      cardType: getCardType(item.type),
      expiryDate: item.expiry
    };
    if (typeof item.is_mada === 'boolean') {
      paymentMethod.isMada = item.is_mada;
    }
    return paymentMethod;
  });
};

export const userWalletConfigDtoToModel = ({
  is_zero_wallet_balance,
  wallet_details: { amount: smallerUnits, currency, fraction_digits }
}: UserWalletConfigDto): UserWalletConfigModel => {
  const amount = !isNaN(smallerUnits) ? smallerUnits / Math.pow(10, fraction_digits) : smallerUnits;
  return {
    isZeroWalletBalance: is_zero_wallet_balance,
    userBalance: {
      amount,
      currency,
      fractionDigits: fraction_digits
    }
  };
};
